import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {
  Button, Alert, Breadcrumb, BreadcrumbItem,
  Modal, ModalBody, ModalFooter, ModalHeader, Row, Col
} from 'reactstrap';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { Helmet } from "react-helmet";
import Typography from "@material-ui/core/Typography";

class CarerIncidentReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      isProcessing: false,
      action: 'incident',
      showModal: false, // Controls modal visibility
      modalMessage: "",
      incidentType: "", // Selected incident type
      incidentDetails: "", // Incident description
      capturedImage: null, // Store image file
    };
    this.isMountedFlag = false;
    this.timeoutIdRef = null;
    this.fileInputRef = React.createRef();
  }

  componentDidMount() {
    this.isMountedFlag = true;
    const searchParams = new URLSearchParams(this.props.location.search);
    const actionValue = searchParams.get("action");
    const vidValue = searchParams.get("vid");
    this.setState({
      action: actionValue || 'incident',
      visitId: vidValue,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const actionValue = searchParams.get("action");
      this.setState({ action: actionValue || 'incident' });
    }

    // Handle success response from Redux
    if (
      this.props.updateVisitSuccess &&
      prevProps.updateVisitSuccess !== this.props.updateVisitSuccess
    ) {
      console.log("updateVisitSuccess", this.props.updateVisitSuccess);
      this.setState({
        isProcessing: false,
        showModal: true,
        modalMessage: this.props.updateVisitSuccess.message,
      });
    }

    // Handle error response from Redux
    if (
      this.props.updateVisitError &&
      prevProps.updateVisitError !== this.props.updateVisitError
    ) {
      if (this.props.updateVisitError.status === 401) {
        this.props.history.push("/login");
        return;
      }
      this.setState({
        isProcessing: false,
        message: this.props.updateVisitError.response.message
      });
    }
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
    if (this.timeoutIdRef) {
      clearTimeout(this.timeoutIdRef);
    }
  }

  handleModalClose = () => {
    this.setState({ showModal: false });
    this.props.history.push('/ecm/call-logging/');
  };

  handleIncidentTypeChange = (event) => {
    this.setState({ incidentType: event.target.value });
  };

  handleDetailsChange = (event) => {
    this.setState({ incidentDetails: event.target.value });
  };

  handleCaptureImage = () => {
    this.fileInputRef.current.click();
  };

  handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({ capturedImage: file });
    }
  };

  handleSubmit = () => {
    const { incidentType, incidentDetails, capturedImage, visitId } = this.state;
    const { updateVisit } = this.props; // Get updateVisit from props (Redux action)

    if (!incidentType || !incidentDetails) {
      this.setState({ message: "Please fill in all required fields." });
      return;
    }

    const formData = new FormData();
    formData.append("action", "incident-report");
    formData.append("incidentType", incidentType);
    formData.append("incidentDetails", incidentDetails);
    formData.append("event_id", visitId);
    if (capturedImage) {
      formData.append("image", capturedImage);
    }

    this.setState({ isProcessing: true });

    // Dispatch Redux action to update visit with incident report
    updateVisit(formData);
  };

  render() {
    const { message, isProcessing, incidentType, incidentDetails, capturedImage } = this.state;

    return (
      <React.Fragment>
        {/* Modal */}
        <Modal isOpen={this.state.showModal} toggle={this.handleModalClose}>
          <ModalHeader style={{ fontWeight: "bold"}} toggle={this.handleModalClose}>
            Submission Successful
          </ModalHeader>
          <ModalBody>{this.state.modalMessage}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleModalClose}>OK</Button>
          </ModalFooter>
        </Modal>

        <Helmet>
          <meta name="description" content="Electronic call monitoring" />
          <title>Excel Healthcare Services - Social and Domiciliary Care</title>
        </Helmet>

        <main>
          <div>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>Incident and Accident</BreadcrumbItem>
            </Breadcrumb>
          </div>
        </main>

        <div className='container'>
          <div className="scanner-page">
            <div className="row" style={{ marginBottom: "30px", paddingLeft: "15px" }}>
              <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                Report Incident or Accident
              </Typography>
            </div>

            {message && (
              <Alert color={message.toLowerCase().includes('successful') ? 'success' : 'danger'}>
                {message}
              </Alert>
            )}

            <div className="scanner-container">
              {/* Incident Type Dropdown */}
              <Row className="mt-4">
                <Col xs={3}>Type of Incident:</Col>
                <Col xs={9}>
                  <select className="form-control" value={incidentType} onChange={this.handleIncidentTypeChange}>
                    <option value="">Select an Incident Type</option>
                    <option value="Accident">Accident</option>
                    <option value="Incident">Incident</option>
                    <option value="Near Miss">Near Miss</option>
                    <option value="Other">Other</option>
                  </select>
                </Col>
              </Row>
              <hr className="call-log-sect-line"/>

              {/* Image Capture */}
              <Row className="mt-4">
                <Col xs={3}>Picture:</Col>
                <Col xs={9}>
                  <Button color="secondary" onClick={this.handleCaptureImage}>
                    <CameraAltIcon style={{ marginRight: "5px" }} /> Upload Image
                  </Button>
                  <input
                    type="file"
                    accept="image/*"
                    capture="environment"
                    ref={this.fileInputRef}
                    style={{ display: "none" }}
                    onChange={this.handleImageUpload}
                  />
                  {capturedImage && (
                    <div style={{ marginTop: "10px" }}>
                      <img src={URL.createObjectURL(capturedImage)} alt="Captured" width="100" height="100" />
                    </div>
                  )}
                </Col>
              </Row>
              <hr className="call-log-sect-line"/>

              {/* Incident Details */}
              <Row className="mt-4">
                <Col xs={3}>Details:</Col>
                <Col xs={9}>
                  <textarea
                    className="form-control"
                    placeholder="Enter details about the incident..."
                    rows="4"
                    value={incidentDetails}
                    onChange={this.handleDetailsChange}
                  />
                </Col>
              </Row>
              <hr className="call-log-sect-line"/>

              {/* Submit Button */}
              <Row className="mt-4">
                <Col xs={{ size: 9, offset: 3 }}>
                  <Button color="primary" onClick={this.handleSubmit} disabled={isProcessing}>
                    {isProcessing ? "Submitting..." : "Submit Report"}
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(CarerIncidentReport);
